export default __webpack_public_path__ + "static/media/Know_your_customers_business.ed369869.png";